import * as C from "@radix-ui/react-checkbox"
import { CheckIcon } from "@radix-ui/react-icons"
import { tv } from "@utils/tw"
import { ReactNode, useId } from "react"

type CheckboxProps = {
  name?: string
  label?: ReactNode
  desccription?: ReactNode
  checked?: boolean
  required?: boolean
  onCheckedChange?: (checked: boolean) => void
}

export function Checkbox(props: CheckboxProps) {
  const id = useId()
  const styles = checkboxStyles({})
  return (
    <div className={styles.wrapper()}>
      <C.Root
        name={props.name}
        required={props.required}
        className={styles.box()}
        checked={props.checked}
        onCheckedChange={props.onCheckedChange}
        id={id}
      >
        <C.Indicator>
          <CheckIcon />
        </C.Indicator>
      </C.Root>
      {props.label && (
        <div className={styles.label()}>
          <label htmlFor={id} className="cursor-pointer">
            {props.label}
          </label>
        </div>
      )}
      {props.desccription && <div className={styles.description()}>{props.desccription}</div>}
    </div>
  )
}

export const checkboxStyles = tv({
  slots: {
    wrapper: "grid gap-x-3 gap-y-2 grid-cols-[auto,1fr]",
    box: [
      "relative col-span-1 col-start-1 row-start-1 size-4 flex items-center justify-center rounded-sm flex-none",
      "focus-visible:ring-input outline-none",
      "bg-secondary text-secondary-foreground border border-secondary-foreground/20",
      "before:absolute before:-inset-1 before:-right-3 before:block",
      "flex-none",
    ],
    info: "flex flex-col gap-2",
    label: "col-span-1 col-start-2 row-start-1 type-caption flex items-center",
    description: "col-span-1 col-start-2 row-start-2 type-caption text-black/40 max-w-[40em] text-pretty",
  },
})
